import React, { useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import "./Stories.scss";
import { new_image_thumbnail, premiermemberAd } from "shared/images/images";
import { useEffect, useState } from "react";
import { Button,Form } from "react-bootstrap";
import { Adsense } from "shared/utils/Adsense";
import { ADSENSE } from "shared/settings/config";
import axios from "axios";
import { getBuyerHeaders, getBuyersUrl } from "shared/http";
import { newsandstories } from "shared/settings/apiconfig";
import moment from 'moment';
import { Pagination } from "../HOC/Pagination";
import { Loader } from "shared/hoc/loader/Loader";
import { Breadcrumbs } from "shared/hoc/breadcrumbs/Breadcrumbs";
import { BREADCRUMB_TYPE_CONFIG } from "shared/hoc/breadcrumbs/config";
import { addDataLayer } from "shared/utils/utils";
import { searchIcon } from "shared/assets/icons";

export const NewsAndStories = (props) => {

  const dispatch = useDispatch();
  const statemaintenance = useSelector(state => state?.statemaintenance);
  const currentindex = useRef(1)
  const totalrecord = useRef(0)
  const [imageLoaded, setImageLoaded] = useState(false);
  const [stories, setStories] = useState({});
  const [pageLoading, setPageLoading] = useState(true);
  const [serachText, setSearchText] = useState('');
  const [sortValue, setSortValue] = useState('');
  const [hasSearched, setHasSearched] = useState(false);

  useEffect(() => {
    if(statemaintenance?.["stories"] ) {
        let data = statemaintenance?.["stories"]
        setSortValue(statemaintenance?.["stories"].sort)
        setSearchText(statemaintenance?.["stories"].serachvalue)
        totalrecord.current = data?.total
        getNewsAndStoriesContent(data?.["pagekey"], data?.currentPage, '', data);
    } else {
        getNewsAndStoriesContent();
    }
  }, []);
  
  useEffect(() => {
    if (hasSearched && serachText === "") {
      getNewsAndStoriesContent();
    }
  }, [serachText, hasSearched])

  const navigateToSection = (data) => {
    if(data.htmlcontent) {
      let dataLayerData = {
          'event': 'story_view',
          'title': window.location.href+`/stories/${data.id}`
      }
      addDataLayer(dataLayerData);
      props.history.push(`/stories/${data.id}`);
    } else {
      let dataLayerData = {
          'event': 'story_view',
          'title': data.storylink
      }
      addDataLayer(dataLayerData);
      window.open(data.storylink);
    }
    
  }

  const handleserach = (event) => {
    if(event.target.value) {
      let pusttoStore = { ...statemaintenance }
      pusttoStore["stories"] = {
        ...pusttoStore?.["stories"],
        serachvalue: event.target.value,
      }
      dispatch({
        type: 'PUSH_TO_STATE', payload: pusttoStore
      });
      setSearchText(event.target.value);
    } else {
      if(event.target.value == "") {
        setSearchText("");
        setHasSearched(true);
      }
    }
  }

  const getNewsAndStoriesContent = (page=null, currentPageNumber=1, previousPageNumber=0, stateData, event) => {
    setPageLoading(true);
    const data = {
      page: { size: 8, pagenumber: 1, ...page },
      sort: [],
      filter: serachText || stateData?.serachvalue ? [
            { field: "title", value: serachText || stateData?.serachvalue, op: "LIKE", join: "OR" },
            { field: "publishername", value: serachText || stateData?.serachvalue, op: "LIKE", join: "OR" },
            { field: "summary", value: serachText || stateData?.serachvalue, op: "LIKE", join: "OR" },
          ]: [],
    };
    let sortValues = event?.target?.value ? event?.target?.value : sortValue ? sortValue : stateData?.sort
    data.sort.push({
      field: "publisheddate",
      direction: sortValues === "old-to-new" ? "asc" : "desc",
    })
    
    axios.post(getBuyersUrl(`${newsandstories}`), JSON.stringify(data), getBuyerHeaders())
      .then(async response => {
        if(response?.data?.page?.total) {
            totalrecord.current = response?.data?.page?.total
        }
        currentindex.current = currentPageNumber
        let pusttoStore = { ...statemaintenance }
        pusttoStore["stories"] = {
            sort : sortValue,
            serachvalue : serachText,
            pagekey: page,
            currentPage: currentPageNumber,
            previousPage:previousPageNumber,
            total: totalrecord?.current
        }
        dispatch({
            type: 'PUSH_TO_STATE', payload: pusttoStore
        });
        setPageLoading(false);
        setStories(response.data);
      }).catch((error) => {
        setPageLoading(false);
      })
  }

  return (
    <div className="flex-fill">
      <div>
         <Breadcrumbs props={props} type={BREADCRUMB_TYPE_CONFIG.NEWSANDSTORIES} />
      </div>
      <div className="news-stories-container w-100">
        <div className="sidebar">
          {(!props.user.membershipCompleted && window.innerWidth > 1025) && 
            <div className='text-center premier-img clickable w-100' style={{ position: 'relative', marginBottom: "10px", minHeight: '100px' }} >
                <img src={premiermemberAd} onLoad={() => setImageLoaded(true)}   onClick={() => props.history.push('/plans')} style={{ width: '50%' }} className='w-100 image-section' alt="advertise-image" />
               {imageLoaded && <div className='join-btn'>
                    <button className='join-btn1' onClick={() => props.history.push('/plans')}>
                        Join Today
                    </button>
                </div>}
            </div>
          }

          <div>
            {ADSENSE.ENABLE && window.innerWidth > 1025 ? <Adsense googleAdCenter slotId={ADSENSE.ITEM_VIEW.slotId} /> : ""}
          </div>
        </div>

        <div className="d-flex flex-column align-items-center news-and-stories-segment">
          <h1 style={{ color: "#00263E" }}><b>News and Stories</b></h1>

          <div className="d-flex flex-column align-items-center w-100">
            <div className="d-flex justify-content-center align-items-center mt-3 gap-4 flex-wrap">

              {/* Left: Sort Dropdown */}
              <div className="d-flex align-items-center">
                <p className='me-2 mb-0 fw-bold'>Sort by</p>
                <Form.Group className="mb-0">
                  <Form.Select
                    aria-label='sort by'
                    name="storiesSort"
                    value={sortValue}
                    className="sort"
                    onChange={(event) => {
                      setSortValue(event.target.value)
                      getNewsAndStoriesContent(null, 1, 0,"", event)
                    }}
                  >
                    <option value="new-to-old">Newest to Oldest</option>
                    <option value="old-to-new">Oldest to Newest</option>
                  </Form.Select>
                </Form.Group>
              </div>

              {/* Right: Search Input + Button */}
              <div className="d-flex align-items-center">
                <div className="input-group me-2" style={{ maxWidth: '250px' }}>
                  <span className="input-group-text bg-white border-end-0 px-2">
                    {searchIcon}
                  </span>
                  <input
                    name="serachText"
                    onChange={(event) => handleserach(event)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        getNewsAndStoriesContent(null, 1, 0)
                      }
                    }}
                    className="form-control border-start-0"
                    id="advance-sale-search-input"
                    aria-label="Search this sale..."
                    placeholder="Search news and stories..."
                    style={{ padding: '5px' }}
                    value={serachText}
                  />
                </div>

                <button
                  type="button"
                  className="btn"
                  onClick={() => getNewsAndStoriesContent(null, 1, 0)}
                  style={{
                    color: "#99004C",
                    fontWeight: "bold",
                    fontSize: "14px",
                    background: "none",
                    border: "none",
                  }}
                >
                  Search
                </button>
              </div>

            </div>
          </div>

          {/* <p className="mt-3" style={{ color: "#00263E", fontSize: "18px" }}>To receive first alerts on our new drops and latest updates regarding listings</p> */}
          <div className="mt-3 stories-resp w-100">
            {
              pageLoading ?
                <Loader /> :
                Array.isArray(stories.data) && stories.data.length > 0 ?
                  stories.data.map((elem) => {
                    return (
                      window.innerWidth <= "698" ? 
                      <div className="w-100 mt-3" style={{ borderBottom: "1px solid var(--Border-default, #DEE2E6)" }} onClick={() => { navigateToSection(elem) }}>
                        <div className="d-flex gap-5">
                          <div className="d-flex align-items-center justify-content-center" style={{ width: "40%" }}>
                            <img style={{ width: `${elem.coverimage ? '100%' : "60%" }`, height: "100%", objectFit: "cover" }} src={elem.coverimage ? elem.coverimage : new_image_thumbnail} alt="news-stories-img" />
                          </div>
                          <div className="d-flex flex-column" style={{ width: "60%" }}>
                            <div className="story-title" dangerouslySetInnerHTML={{ '__html': elem.title }}  title={ elem.title.replace(/<[^>]+>/g, '') }></div>
                            <div className="mt-3 mobile-line" style={{ borderTop: "1px solid #00263E", width: "100%" }} />
                            <div className="d-flex flex-column">
                                <div className="mt-3 mb-3 publisher">By {elem.publishername} </div>
                                <div>{elem.publisheddate ? "|" + moment(elem.publisheddate).format("DD MMMM YYYY") : ""}</div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-3 mb-3 story-summary" dangerouslySetInnerHTML={{ '__html': elem.summary }}  title={ elem.summary.replace(/<[^>]+>/g, '') }></div>
                      </div> :
                      <div className="w-100 d-flex align-items-center p-3 clickable gap-5" style={{ borderBottom: "1px solid var(--Border-default, #DEE2E6)" }} onClick={() => { navigateToSection(elem) }}>
                        <div className="w-40 d-flex align-items-center justify-content-center" style={{ height: "200px" }}>
                          <img style={{  width: `${elem.coverimage ? '100%' : "none" }`, height: "100%", objectFit: "cover" }} src={elem.coverimage ? elem.coverimage : new_image_thumbnail} alt="news-stories-img" />
                        </div>
                        <div className="w-60 d-flex flex-column">
                          <div className="mt-3 story-title" dangerouslySetInnerHTML={{ '__html': elem.title }} title={ elem.title.replace(/<[^>]+>/g, '') }></div>
                          <div className="mt-3 story-summary" dangerouslySetInnerHTML={{ '__html': elem.summary }} title={ elem.summary.replace(/<[^>]+>/g, '') }></div>
                          <div className="mt-3 mobile-line" style={{ borderTop: "1px solid #00263E", width: "30%" }} />
                          <div className="d-flex">
                                <div className="mt-3 mb-3 publisher">By {elem.publishername} </div>
                                <div className="mt-3 mb-3 publisher">{elem.publisheddate ? " | " + moment(elem.publisheddate).format("DD MMMM YYYY") : ""}</div>
                            </div>
                        </div>
                      </div>
                    )
                  }) : <div
                  className="d-flex justify-content-center align-items-center" style={{height: '50vh'}}>
                  <div className="text-center text-bold fs-20 ">No Results found</div>
                </div>
            }
          </div>
        </div>
      </div>
      {Array.isArray(stories.data) && stories.data.length > 0 && <Pagination loading={pageLoading} page={stories.page} onPageChangeCallback={(page, currentPageNumber, previousPageNumber) => { getNewsAndStoriesContent(page, currentPageNumber, previousPageNumber) }} type="stories"
        pageData={{
          currentindex: currentindex.current,
          total: totalrecord?.current
        }} />}
      {(!props.user.membershipCompleted && window.innerWidth < 1025) && <div className='text-center premier-img clickable w-100' style={{ position: 'relative' }} >
        <img src={premiermemberAd} onClick={() => props.history.push('/plans')} style={{ height: '500px' }} className='image-section' alt="advertise-image" />
            <div className="join-btn">
              <button className="join-btn1" onClick={() => props.history.push('/plans')}> Join Today </button>
            </div>
          </div>}
     
      <div className="d-flex justify-content-center w-100">
        {ADSENSE.ENABLE ? <Adsense googleAdCenter slotId={ADSENSE.FOOTER.slotId} /> : ''}
      </div>
    </div>
  );
};

export const NewsAndStoriesdetail = (props) => {
  const [htmlContent, setHtmlContent] = useState([]);
  const [footerContent, setFooterContent] = useState([]);
  const [footerLoading, setFooterLoading] = useState(true);
  const [pageLoading, setPageLoading] = useState(true);
  const id = window.location.pathname.split("/").pop();

  useEffect(() => {
    setPageLoading(true);
    let data = {
      "sort": [{ "field": "createddate", "direction": "desc" }],
      "page": { "size": 8, "pagenumber": 1 },
      "filter": [
        { "field": "id", "value": id, "op": "=", "join": "AND" }
      ]
    }
    axios.post(getBuyersUrl(`${newsandstories}`), JSON.stringify(data), getBuyerHeaders())
      .then(async response => {
        let data = response.data.data;
        setPageLoading(false);
        setFooterLoading(false);
        setHtmlContent(data);
        if (data.length > 0) {
          getFooterData(data[0]);
        }
      }).catch((error) => {
        setPageLoading(false);
        setFooterLoading(false);
      })
  }, [id]);

  const getFooterData = (storyData) => {
    let data = {
      "sort": [{ "field": "createddate", "direction": "desc" }],
      "page": { "size": 8, "pagenumber": 1 },
      "filter": [
        { "field": "id", "value": id, "op": "!=", "join": "AND" },
        { "field": "publishername", "value": storyData.publishername, "op": "=", "join": "AND" }
      ]
    }
    axios.post(getBuyersUrl(`${newsandstories}`), JSON.stringify(data), getBuyerHeaders())
      .then(async response => {
        setFooterLoading(false);
        setPageLoading(false);
        setFooterContent(response.data.data);
      }).catch((error) => {
        setPageLoading(false);
        setFooterLoading(false);
      })
  }

  const navigateToStories = (id) => {
    props.history.push(`/stories/${id}`);
  }

  return (
    <div style={{flex: '1'}}>
     <Breadcrumbs props={props} type={BREADCRUMB_TYPE_CONFIG.STORIESVIEW} options={{ key: id }} />
      <div className="news-stories-container d-flex flex-column align-items-center">
        {
          pageLoading || footerLoading ?
           <Loader /> :
           <div className="w-100">
              {htmlContent[0]?.coverimage ? <div className="w-100 mb-3 mt-5">
                  <img style={{ height: "298px", width: "100%" }} src={htmlContent[0].coverimage ? htmlContent[0].coverimage : ''} alt="news-stories-img" />
              </div> : ''}
              {
                Array.isArray(htmlContent) && htmlContent.length > 0 ?
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="main-content">
                      <h1 className="mt-3 font-weight-bold" dangerouslySetInnerHTML={{ __html: htmlContent[0].title }}></h1>
                      <div className="mt-3" style={{ borderTop: "1px solid #00263E", width: "100%" }} />
                      <div className="d-flex">
                        <div className="mt-3 mb-3 publisher">By {htmlContent[0].publishername} </div>
                        <div className="mt-3 mb-3 publisher">{htmlContent[0].publisheddate ? " " + " | " + " " + moment(htmlContent[0].publisheddate).format("DD MMMM YYYY") : ""}</div>
                      </div>
                    </div>
                    <div className="main-content news-and-stories mt-5">
                      <div dangerouslySetInnerHTML={{ __html: htmlContent[0].htmlcontent }} className="stories-segment"/>
                      {/* { 
                        htmlContent[0].storylink ? 
                        <div>
                          <div className="d-flex mt-3 clickable font-weight-bold" onClick={() => {window.open(htmlContent[0].storylink)}}>Story link : </div>
                          <div className="mt-3" style={{ color: "blue" }} dangerouslySetInnerHTML={{ __html: htmlContent[0].storylink }}></div>
                        </div> : ''
                      } */}
                      { htmlContent[0].referenceLink ? <div>
                        <div className="d-flex mt-3 clickable font-weight-bold" onClick={() => {window.open(htmlContent[0].referenceLink)}}>Posted in : </div>
                        <div className="mt-3 clickable stories-segment" style={{ color: "blue", textDecoration: 'underline' }}  dangerouslySetInnerHTML={{ __html: htmlContent[0].referenceLink }} onClick={() => {window.open(htmlContent[0].referenceLink)}}></div>
                      </div> : '' }
                    </div>
                  </div> : 
                  <div className="d-flex align-items-center justify-content-center text-center mt-5">No Results Found</div>
              }
            </div>
        }
      </div>
      {!footerLoading && footerContent.length > 0 ? <div className="d-flex flex-column align-items-center justify-content-center mt-5">
        <div className="mt-3" style={{ fontSize: "20px", fontWeight: "bold" }}>Read more from CTBids Patrons</div>
        <button className="mt-3" style={{ border: "1px solid var(--Border-default, #DEE2E6)", padding: "8px", fontSize: "16px", borderRadius: "5px", backgroundColor: "#FFFFFF", fontWeight: "500" }} onClick={() => { props.history.push("/stories") }}>View More News and Stories</button>
        <div className="d-flex mt-3 container-resp mb-3 justify-content-center" style={{ width: "80%", gap: "2%" }}>
          {
            footerContent.map(elem => (
              <div className="mt-3 p-3 clickable d-flex align-items-center flex-column w-30" style={{ border: "1px solid var(--Border-default, #DEE2E6)" }} onClick={() => { navigateToStories(elem.id) }}>
                <div className="d-flex align-items-center justify-content-center">
                  <img style={{ height: "180px", width: "100%" }} src={elem.coverimage ? elem.coverimage : new_image_thumbnail} alt="news-stories-img" />
                </div>
                <div className="mt-3 footer-caurosel" dangerouslySetInnerHTML={{ __html: elem.title }}></div>
                <div className="mt-3" style={{ borderTop: "1px solid #00263E", width: "100%" }} />
                <div className="d-flex">
                  <div className="mt-3 mb-3 publisher">By {elem.publishername} </div>
                  <div className="mt-3 mb-3 publisher">{elem.publisheddate ? " " + " | " + " " + moment(elem.publisheddate).format("DD MMMM YYYY") : ""}</div>
                </div>
              </div>
            ))
          }
        </div>
      </div> : ""}
      <div className="d-flex justify-content-center w-100 mb-3">
        {ADSENSE.ENABLE ? <Adsense googleAdCenter slotId={ADSENSE.FOOTER.slotId} /> : ''}
      </div>
    </div>
  );
};

class Stories extends React.Component {
  render() {
    return <NewsAndStories {...this.props} />;
  }
}

class StoriesDetailView extends React.Component {
  render() {
    return <NewsAndStoriesdetail {...this.props} />;
  }
}

const Newsandstories = connect((state) => state)(Stories);
const NewsandstoriesDetail = connect((state) => state)(StoriesDetailView);
export { Newsandstories, NewsandstoriesDetail };
